import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CockpitShell from "../components/CockpitShell";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

const navItems = [
  { href: "/dashboard/press", label: "Press Desk", icon: "📰" },
  { href: "/dashboard/account", label: "Account", icon: "🔐" },
  { href: "/stb/job-marketplace", label: "Marketplace", icon: "🌍" },
  { href: "/", label: "Website", icon: "🏠" },
];

const PressDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Experts4Europe | Press Desk";
  }, []);

  return (
    <CockpitShell
      title="Press Intelligence Desk"
      subtitle="Curated visibility into Experts4Europe updates, product milestones, and market narrative."
      badge="Experts4Europe Press"
      navItems={navItems}
      actions={
        <Button className="bg-cyan-500 text-slate-950 hover:bg-cyan-300" onClick={() => navigate("/stb/job-marketplace")}>
          Open Marketplace
        </Button>
      }
    >
      <div className="grid gap-4 md:grid-cols-3">
        <Card className="card-e4e">
          <CardHeader><CardTitle className="font-display text-white">Brand Signal</CardTitle></CardHeader>
          <CardContent className="text-sm text-slate-300">Experts4Europe identity and product language are aligned across the platform.</CardContent>
        </Card>
        <Card className="card-e4e">
          <CardHeader><CardTitle className="font-display text-white">Narrative Focus</CardTitle></CardHeader>
          <CardContent className="text-sm text-slate-300">AI-supported hiring with transparent role separation and operational quality.</CardContent>
        </Card>
        <Card className="card-e4e">
          <CardHeader><CardTitle className="font-display text-white">Media Readiness</CardTitle></CardHeader>
          <CardContent className="text-sm text-slate-300">Dashboard views are responsive and available across desktop, tablet, and mobile devices.</CardContent>
        </Card>
      </div>

      <Card className="card-e4e">
        <CardHeader>
          <CardTitle className="font-display text-white">Press Timeline</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-slate-200">
          <div className="rounded-xl border border-white/10 bg-slate-900/40 p-3">
            <p className="font-semibold text-white">Platform Milestone</p>
            <p className="mt-1 text-slate-300">Role-gated cockpit dashboards restored for Admin, Applicant, Employer, and Press.</p>
          </div>
          <div className="rounded-xl border border-white/10 bg-slate-900/40 p-3">
            <p className="font-semibold text-white">Product Narrative</p>
            <p className="mt-1 text-slate-300">From country-specific MVP to Europe-wide AI talent operations platform.</p>
          </div>
          <Badge variant="outline" className="border-cyan-300/40 bg-cyan-500/10 text-cyan-100">
            LOCAL media workspace active
          </Badge>
        </CardContent>
      </Card>
    </CockpitShell>
  );
};

export default PressDashboard;
